export const loggedUser = {
  company: 'University of Southern California',
  siebelRowId: '2-5WCD6R',

  // data from user-details
  userContactInfo: {
    firstName: 'Keynote ',
    lastName: 'Keynote',
    // userId: 815135,
    // userName: 'TEST003 ',
    // userName: 'KEYNOTE49  ',
    // userId: 765983,
    userName: 'Keynote52',
    userId: 652657,
    contactInfo: {
      country: {
        isoCode: 'us',
      },
    },
    isAnonymous: false,
    locale: 'en',
  },

  userRoles: {
    scms: false,
    roles: ['Enterprise.CustomerServiceRepresentative']
  },

  currencyCode: 'USD',
  customerName: 'Keynote',
  displayIso: 'us',
  displayLang: 'en',
  displayType: 'b2ccmgt',
  emailAddress: 'ITQASupport@thermofisher.com',
  isCSR: false,
  partnerLogo: '',
  shipToNumber: '277488',
  unreadMessagesCount: '0',

  // data from /user-type endpoint
  isAnonymous: false,
  isB2BMasterUser: false,
  isCrmManager: false,
  isSosManager: false,
  userType: 'b2c',
};

export const mockRequestHeaders = {
  userName: loggedUser.userContactInfo.userName,
  userid: loggedUser.userContactInfo.userId,
  countryCode: 'jp',
  // countryCode: 'us', Uncomment to check redirect to old app (still pending for us users)
};

export const cartRequestMockHeaders = {
  countryCode: 'us',
  'request-env': 'qa1',
  languageCode: 'en',
  currencyCode: 'USD',
  // cart id for test003
  // cartId: 24766005,
  // cart id for Keynote52
  cartId: 25008489,
};

export const uploadedFileResponse = {
  plateStatuses: [
    {
      plateName: 'PLATE_01',
      isValid: false,
      errors: [
        {
          code: 'INVALID_OLIGO_SEQUENCE_LENGTH',
          defaultMessage:
            'Invalid Oligo sequence. Length should be between 5 and 100 bases.',
        },
        {
          code: 'INVALID_3PRIME_5PRIME_MODIFICATIONS',
          defaultMessage: `The 5' modification (ALD) and 3'modification (BIO) requested are not 
          compatible and can not be manufactured on the same oligo sequence.`,
        },
      ],
    },
    {
      plateName: 'PLATE_02',
      isValid: true,
      errors: [],
    },
    {
      plateName: 'PLATE_03',
      isValid: true,
      errors: [],
    },
  ],
  fileName: '3plates-2err-plate1.xlsx',
  platesCount: 3,
  oligosCount: 193,
  basesCount: 3844,
  shippingDays: 1,
};

export const fileUploadResponse = {
  plateStatuses: [
    {
      plateName: 'PLATE_01',
      isValid: true,
      errors: []
    }, {
      plateName: 'PLATE_05',
      isValid: true,
      errors: []
    }
  ],
  fileName: 'DNA_Plate_template_global_96well(2).xls',
  platesCount: 1,
  oligosCount: 96,
  basesCount: 1920,
  shippingDays: -1,
  plateSize: 96,
  plateSettingsResponse: {
    wellVolume: 200,
    synthesisScale: 'N_25',
    purification: 'DESALTED',
    buffer: 'TE',
    qualityTestingPercentage: 25,
    shipFormat: 'DRIED'
  }
};
